import { AxiosError } from 'axios';

import { CareerSiteLanguageType } from '@locale/locale-store';

import { JobOrderingData } from '../jobs/requests';
import { unhandledRequest } from '../request';

export type Translation = {
  title: string;
  language: CareerSiteLanguageType;
};

export type Department = {
  id: number;
  externalId: string;
  translations: Translation[];
  numJobs: number;
  numUsers: number;
  users: number[];
  hasAccess: boolean;
  canEditFullAccess: boolean;
  title?: string;
};

export type SubmitError = AxiosError<{
  ordering: string;
  error: string;
}>;

export type DepartmentOrderingData = {
  id: number;
  title: string;
  order: number;
  pinned: boolean;
  jobs: JobOrderingData[];
};

export async function list() {
  const response = await unhandledRequest.get<Department[]>({
    url: '/departments/',
  });

  return response.data;
}

export async function noDepartmentsInfo() {
  const response = await unhandledRequest.get<{ jobs: number; users: number }>({
    url: '/departments/no-departments-info/',
  });
  return response.data;
}

export function create(externalId: string, translations: Translation[]) {
  return unhandledRequest.post({
    url: '/departments/',
    data: { translations, externalId },
  });
}

export function edit(departmentId: number, externalId: string, translations: Translation[]) {
  return unhandledRequest.patch({
    url: `/departments/${departmentId}/`,
    data: { translations, externalId },
  });
}

export function remove(departmentId: number) {
  return unhandledRequest.delete({ url: `/departments/${departmentId}/` });
}

export function addUser(departmentId: number, userId: string, fullAccess: boolean) {
  return unhandledRequest.post({
    url: `users/${userId}/departments/`,
    data: { department: departmentId, fullAccess },
  });
}

export function addUsers(departmentId: number, userIds: string[], fullAccess: boolean) {
  return unhandledRequest.post({
    url: `departments/${departmentId}/add-users/`,
    data: { userIds, fullAccess },
  });
}

export function editUser(departmentId: number, userId: number, fullAccess: boolean) {
  return unhandledRequest.patch({
    url: `users/${userId}/departments/${departmentId}/`,
    data: { fullAccess },
  });
}

export function removeUser(departmentId: number, userId: number) {
  return unhandledRequest.delete({ url: `users/${userId}/departments/${departmentId}/` });
}

export async function getDepartmentOrder() {
  const response = await unhandledRequest.get<DepartmentOrderingData[]>({
    url: 'departments/jobs/ordering/',
  });
  return response.data;
}

export async function pinDepartment(departmentId: number, order: number) {
  return unhandledRequest.post({
    url: `departments/${departmentId}/pin/`,
    data: { order },
  });
}

export async function unpinDepartment(departmentId: number) {
  return unhandledRequest.delete({
    url: `departments/${departmentId}/pin/`,
  });
}
